import { useParams, getUserTimezone } from "duck";
import { usePrintDentalReportMutation } from "requests";

export const usePrintDentalReport = () => {
  const { id: caseId } = useParams();
  const [print, { loading }] = usePrintDentalReportMutation({
    variables: {
      input: { medicalCase: +caseId, userTimezone: getUserTimezone() }
    }
  });

  return {
    print: () =>
      print().then(result => {
        const fileId =
          result.data?.createDentalReportPrint?.dentalReportPrint?.file?._id;
        if (fileId) {
          window.open(
            `${process.env.REACT_APP_UPLOAD_URL}/files/${fileId}/show`,
            "_blank"
          );
        }
      }),
    loading
  };
};
